import { render } from "./DaftarGESIAP.vue?vue&type=template&id=3dd75761"
import script from "./DaftarGESIAP.vue?vue&type=script&lang=js"
export * from "./DaftarGESIAP.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__